var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempNotificacaoWeb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 802,
    height: 450,
    viewBox: "0 0 802 450",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_118_2756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 21,
    width: 746,
    height: 394,
    rx: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 195.77,
    width: 154.785,
    height: 60.0956,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 244.028,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 208.517,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 222.175,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 112,
    width: 154.785,
    height: 66.8013,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 149.332,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 136.585,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 167.543,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 123.837,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 285.913,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 271.344,
    width: 154.785,
    height: 51.9008,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.29,
    y: 308.677,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 195.77,
    width: 154.785,
    height: 60.0956,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 244.028,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 208.517,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 222.175,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 112,
    width: 154.785,
    height: 66.8013,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 149.332,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 136.585,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 167.543,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 123.837,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 285.913,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 271.344,
    width: 154.785,
    height: 51.9008,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.29,
    y: 308.677,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 195.77,
    width: 154.785,
    height: 60.0956,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 244.028,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 208.517,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 222.175,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 112,
    width: 154.785,
    height: 66.8013,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 149.332,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 136.585,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 167.543,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 123.837,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 285.913,
    width: 119.21,
    height: 6.37378,
    rx: 3.18689,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507,
    y: 271.344,
    width: 154.785,
    height: 51.9008,
    rx: 20,
    fill: "#D9D9D9",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.29,
    y: 308.677,
    width: 26.39,
    height: 3.64216,
    rx: 1.82108,
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_118_2756",
    x: 0,
    y: 0,
    width: 802,
    height: 450,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_118_2756"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_118_2756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_118_2756",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempNotificacaoWeb);
export default __webpack_public_path__ + "static/media/TempNotificacaoWeb.59728ba1e4cc9eb56c136e7e64e43425.svg";
export { ForwardRef as ReactComponent };